import IDividend from "../models/IDividend";
import Utils from "../portlibs/PortUtils"
import { usePath } from "../libs/path/PathProvider"
import React, { ReactElement, useMemo } from "react"
import usePortfolio from "../hooks/PortfolioProvider"
import GUI from "../gui/GUI";
import Calendar from "../gui/Calendar/Calendar";
import Tooltip from "../gui/Overlay/Tooltip";
import Toolbar from "../components/widgets/Toolbar";
import DateRangeFilter from "../components/widgets/DateRangeFilter";

type TDivCalendarProps = {
    className:string
    month:number;
    start:Date;
    end:Date;
    total:number
    totalThis:number
    totalFuture:number
    divs:IDividend[]
}
function DivDay(props:{date:Date,year:number,divs:IDividend[]}) {
    const date = props.date.getDate()
    const pays : JSX.Element[] = []
    let total = 0;
    let key = 0;
    for(let div of props.divs){
        if (Utils.dateEq(props.date, div.date)) {
            total += div.amount * div.holding.exchange;
            const amount = Utils.formatCurrency(div.holding.currency, div.amount)
            pays.push(<div key={key++} className={div.future ? "future" : ""}>{`${div.id} ${amount}`}</div>)
        }
    }
    let klass = total ? "filled" : ""
    if (total>=300) klass += " C300";
    else if (total>=250) klass += " C250";
    else if (total>=200) klass += " C200"
    else if (total>=150) klass += " C150";
    else if (total>=100) klass += " C100";
    else if (total>=50) klass += " C50";
    if (key) pays.push(<div key={key++} className="total">{Utils.formatCurrency(0, total)}</div>)
    const tooltip = pays.length ? {tooltip:pays} : {}
    return <Tooltip {...tooltip} className={klass} tooltipClass="dividend">{date}</Tooltip>
}

function getDividens(year:number, month:number){
    const {query} = usePath();
    const {account,currency,filter} = useMemo(() => ({account:Utils.account,currency:Utils.currency,filter:Utils.filter}), [query])
    const {portfolio} = usePortfolio()

    const divs:IDividend[] = []
    const holdings = portfolio.filter(currency, filter, account, false)
    let total = 0, totalThis = 0, totalFuture = 0
    for(let holding of holdings) {
        for(let dist of holding.distributions) {
            if (dist.date.getMonth()==month && dist.date.getFullYear()==year) {
                divs.push(dist)
                const amount = dist.amount * dist.holding.exchange;
                total += amount
                if (dist.future) totalFuture += amount
                else totalThis += amount
            }
        }
    }
    return {divs, total, totalThis, totalFuture}
}
function DivCalendar(props:TDivCalendarProps){
    let totalE:ReactElement[] = []
    const {totalThis,totalFuture,total,divs} = props
    const year = props.start.getFullYear()
    if (totalThis && totalFuture){
        totalE.push(
            <span className="done" key="done">{Utils.formatCurrency(0, totalThis)}</span>,
            <span className="future" key="future">{Utils.formatCurrency(0, totalFuture)} *</span>,
            <span className="sum" key="total">{Utils.formatCurrency(0, total)}</span>
        )
    }
    else if (totalFuture){
        totalE.push(
            <span className="future" key="future">{Utils.formatCurrency(0, totalFuture)} *</span>
        )
    }
    else {
        totalE.push(
            <span className="done" key="done">{Utils.formatCurrency(0, total)}</span>
        )
    }
    const dayCell = (date:Date) => <DivDay date={date} year={year} divs={divs}/>
    return <div className={GUI.joinClass("cell", props.className)}><Calendar readOnly={true} visible={props.start} cellRenderer={dayCell}/><div className="total">{totalE}</div></div>
}
function DivDate(props:{date:string, divs:IDividend[]}) {
    const rows = props.divs.map(div => <div className="dividend" key={div.id}><div>{div.id}</div><div className="amount">{Utils.formatCurrency(0, div.holding.exchange*div.amount)}</div></div>)
    return <>
        <div className="date">{props.date}</div>
        {rows}
    </>
}
export default function DivCalendars(){
    const {query} = usePath()
    const year = parseInt(query.year as string) || new Date().getFullYear();
    const months : any[] = []
    const dates : any[] = []
    const upcomings : Record<string,IDividend[]> = {}
    const divDates : string[] = []

    let start = new Date(year, 0, 1, 0, 0, 0);
    for(let i=0; i<24; i++) {
        let end = new Date(new Date(start).setMonth(start.getMonth()+1))
        const divs = getDividens(start.getFullYear(), start.getMonth())
        months.push(<DivCalendar key={i} month={i%12} start={start} end={end} className={i>=12 ? "alt" : ""} {...divs}/>)
        start = end

        const future = divs.divs.filter(div => div.future)
        for(const row of future){
            const date = Utils.formatDate("yyyy-MM-dd", row.date)
            if (date in upcomings) upcomings[date].push(row)
            else {
                upcomings[date] = [row]
                divDates.push(date)
            }
        }
    }
    divDates.sort()
    for(const date of divDates){
        dates.push(<DivDate key={date} date={date} divs={upcomings[date]}/>)
    }
    return <>
        <Toolbar><DateRangeFilter/></Toolbar>
        <div id="calendars" className="flex1 flex">
            <div className="calendars">{months}</div>
            <div className="dates flex1">{dates}</div>
        </div>
    </>
}